import { clientEnv } from '@pricedrop/config/client';
import { emailOTPClient, oneTapClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { getBaseURL } from './base-url';

const googleClientId = clientEnv.GOOGLE_CLIENT_ID;

export const authClient = createAuthClient({
  baseURL: `${getBaseURL()}/api/auth`,
  plugins: [
    emailOTPClient(),
    ...(googleClientId
      ? [
          oneTapClient({
            clientId: googleClientId,
            autoSelect: false,
            cancelOnTapOutside: true,
            context: 'signin',
          }),
        ]
      : []),
  ],
});

export const { useSession, signOut } = authClient;
